import React from "react";
import { Row, Statistic, Table } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons/lib";
import { BacktestSel } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";

export default () => {
  const strategyReturnsBySymbol =  useRootSelector(BacktestSel.strategyReturnsBySymbol);

  const columns = [
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "Average Returns All Round Trips",
      dataIndex: "avgReturnsAllRoundTrips",
      key: "avgReturnsAllRoundTrips",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Average Returns (Winning)",
      dataIndex: "avgReturnsWinning",
      key: "avgReturnsWinning",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Average Returns (Losing)",
      dataIndex: "avgReturnsLosing",
      key: "avgReturnsLosing",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Median Returns All Round Trips",
      dataIndex: "medianReturnsAllRoundTrips",
      key: "medianReturnsAllRoundTrips",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Median Returns (Winning)",
      dataIndex: "medianReturnsWinning",
      key: "medianReturnsWinning",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100} 
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Median Returns (Losing)",
      dataIndex: "medianReturnsLosing",
      key: "medianReturnsLosing",
      render: (value: number) => (
        <Row justify={"center"}>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Largest Trade (Winning)",
      dataIndex: "largestWinningTrade",
      key: "largestWinningTrade",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
    {
      title: "Largest Trade (Losing)",
      dataIndex: "largestLosingTrade",
      key: "largestLosingTrade",
      render: (value: number) => (
        <Row>
          <Statistic
            value={value * 100}
            precision={2}
            valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
            prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
            suffix="%"
          />
        </Row>
      )
    },
  ];

  return <Table dataSource={strategyReturnsBySymbol.map(e => flatten(e))} columns={columns} pagination={false} />;

  function flatten(obj: any) {
    return Object.keys(obj).reduce((acc: any, current: any) => {
      const _key = `${current}`;
      const currentValue = obj[current];
      if (Array.isArray(currentValue) || Object(currentValue) === currentValue) {
        Object.assign(acc, flatten(currentValue));
      } else {
        acc[_key] = currentValue;
      }
      return acc;
    }, {});
  };

}
